import React, { useState } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import {
  sizeIcon,
} from '../../assets';
import {
  Panel,
  RecommendationIcon,
  RecommendationLabel,
  RecommendationValue,
} from './SizePanelElements';

type Props = {
  matching?: any,
};

const SizeOnlyPanel: React.FunctionComponent<Props> = (props) => {

  const { matching } = props;
  const { size } = matching;
  const sizeNumber = size.value;
  const sizeDescription = size.description;

  return (
    <Panel>
      <RecommendationIcon src={sizeIcon} />
      <RecommendationLabel>
        <FormattedMessage id="drv.matching.size.label"></FormattedMessage>
      </RecommendationLabel>
      <RecommendationValue>{sizeNumber} {sizeDescription}</RecommendationValue>
    </Panel>
  );
};

export default SizeOnlyPanel;
